import { Radio } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { MyForm } from '~/components/ui/MyForm'
import { SuperType } from '~/graphqls/types'
import { isNullOrUndefined } from '~/utils'
import styles from '../AiForm.module.css'
import {
  genTidalAtom,
  resolutionOriginalPointAtom,
  resolutionPointAtom,
  selectResolutionAtom,
  selectSizeAtom,
} from './atom'
import useOptions from './useOptions'
import { useAuth } from '~/hooks/useAuth'
import { useType } from '../useType'
import { useSetDefaultPaintParams } from './useSetDefaultPaintParams'

export const PictureResolutionComp = ({
  hidden = false,
}: {
  /** form item隐藏 */
  hidden?: boolean
}) => {
  const [, setResolutionPoint] = useAtom(resolutionPointAtom)
  const [, setResolutionOriginalPoint] = useAtom(resolutionOriginalPointAtom)
  const [selectResolution, setSelectResolution] = useAtom(selectResolutionAtom)
  const [selectSize, setSelectSize] = useAtom(selectSizeAtom)
  const [genTidal] = useAtom(genTidalAtom)
  const { curResolution, curModelTheme } = useOptions()
  const curResolutionOptions = curResolution[selectSize] || []
  const { isHighUser } = useAuth()
  const { isGeneral } = useType()

  const setDefaultPaintParams = useSetDefaultPaintParams()

  useEffect(() => {
    if (!curResolutionOptions.length) {
      setSelectSize(Object.keys(curResolution)[0])
      return
    }

    // 更新积分
    let index = curResolutionOptions.findIndex(
      item =>
        `${item.length}*${item.width}*${item.superType}` === selectResolution
    )

    // 切换模型时，如果没有找到一致的 resolution，优先保证 resolution 的 superType 一致
    if (index === -1) {
      const suffix = selectResolution?.split('*')[2]
      index = curResolutionOptions.findIndex(it => it.superType === suffix)
    }

    index = index === -1 ? 0 : index

    if (genTidal) {
      // 如果是潮汐模式，需要选中支持潮汐模式的尺寸
      for (let i = index; i >= 0; i--) {
        if (curResolutionOptions[i].supportTidal) {
          let point =
            isHighUser &&
            !isNullOrUndefined(curResolutionOptions[i].membersPrice)
              ? curResolutionOptions[i].membersPrice!
              : curResolutionOptions[i].price

          setSelectResolution(
            `${curResolutionOptions[i].length}*${curResolutionOptions[i].width}*${curResolutionOptions[i].superType}`
          )
          setResolutionPoint(point)
          setResolutionOriginalPoint(curResolutionOptions[i].price)
          break
        }
      }
    } else {
      let point =
        isHighUser &&
        !isNullOrUndefined(curResolutionOptions[index].membersPrice)
          ? curResolutionOptions[index].membersPrice!
          : curResolutionOptions[index].price

      setSelectResolution(
        `${curResolutionOptions[index].length}*${curResolutionOptions[index].width}*${curResolutionOptions[index].superType}`
      )
      setResolutionPoint(point)
      setResolutionOriginalPoint(curResolutionOptions[index].price)
    }
  }, [curResolutionOptions, selectResolution, genTidal])

  const handleResolutionChange = (str: string) => {
    if (str.endsWith(`*${SuperType.FOUR_K}`) && curModelTheme?.fourKDefault) {
      setDefaultPaintParams(curModelTheme?.fourKDefault)
    }
    setSelectResolution(str)
  }

  return (
    <MyForm.Item noStyle hidden={hidden}>
      <Radio.Group
        className={classNames(
          styles.customRadioGroup,
          styles.customPrefineRadio,
          'h-12 !mb-8'
        )}
        onChange={e => {
          handleResolutionChange(e.target.value)
        }}
        value={selectResolution}
      >
        {curResolutionOptions.map(item => {
          const disabled = genTidal && !item.supportTidal
          // 4k分辨率仅支持文生图模式
          if (item.superType === SuperType.FOUR_K && !isGeneral) {
            return null
          }
          return (
            <Radio
              value={`${item?.length}*${item?.width}*${item?.superType}`}
              key={`${item?.length}*${item?.width}*${item?.superType}`}
              className={classNames(styles.customRadio, {
                ['opacity-50 cursor-not-allowed']: disabled,
              })}
              disabled={disabled}
            >
              <div
                className={classNames('radioWrap', {
                  prefine: item.superType === SuperType.PREFINE,
                  fourk: item.superType === SuperType.FOUR_K,
                })}
              >
                <div className="bg-neutral-100 rounded-full">
                  <div
                    className={classNames(
                      'flex items-center justify-center cursor-pointer p-2 border-2 border-solid border-neutral-200 rounded-full duration-75 flex-1 text-center text-xs w-full bg-neutral-200',
                      {
                        'cursor-not-allowed': disabled,
                      }
                    )}
                  >
                    <div className="text-neutral-900">
                      <span className="font-semibold">{`${item?.length}*${item?.width}`}</span>
                      {!!item.price &&
                        !isNullOrUndefined(item.membersPrice) &&
                        isHighUser && (
                          <>
                            <span className="text-neutral-900 ml-1">
                              {item.membersPrice}积分/张
                            </span>
                            <span
                              className={classNames('ml-1', styles.delPrice)}
                            >
                              {item.price}积分
                            </span>
                          </>
                        )}
                      {!!item.price &&
                        (isNullOrUndefined(item.membersPrice) ||
                          !isHighUser) && (
                          <span className="text-neutral-900 ml-1">
                            {item.price}积分/张
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
